import { iconDefaults, type IconProps } from './Icon'

export function CheckIcon(props: IconProps) {
  return (
    <svg {...iconDefaults} {...props}>
    <path d="M5 12.5 10 17.5 19 7" strokeWidth={2.25} />
    </svg>
  )
}
